import { ICartEntry } from '@rbi-ctg/menu';

export const isCartExpired = (timestamp?: number) => {
  const oneHour = 60 * 60 * 1000;
  const currentTime = Date.now();

  return !timestamp || Boolean(currentTime - timestamp > oneHour);
};

const reduceCartEntryChildren = (
  accumulatedPrice: number,
  { children = [], price = 0 }: ICartEntry
): number => accumulatedPrice + children.reduce(reduceCartEntryChildren, price);

export const priceForCartEntry = (item: ICartEntry): number =>
  (item.children || []).reduce(reduceCartEntryChildren, 0) * (item.quantity || 1) +
  (item.price || 0);
